

export default {
    head() {
        return {
            title: `${this.infoGenerales?.attributes?.politiqueDeConfientialiteTitle}`,
            meta: this.infoGenerales?.attributes?.politiqueDeConfidentialiteMeta != null && this.infoGenerales?.attributes?.politiqueDeConfidentialiteMeta != undefined ?
                JSON.parse(this.infoGenerales?.attributes?.politiqueDeConfidentialiteMeta?.replace('\n', '')) : null
        };
        // return {
        //     title: `ICFA - Politique de confidentialité`,
        //     meta: [
        //         {
        //             hid: 'og-title',
        //             property: 'og:title',
        //             content: 'Politique de confidentialité',
        //         },
        //         // {
        //         //     hid: 'og-description',
        //         //     property: 'og:description',
        //         //     content: `Vous avez des questions sur nos formations en alternance? Contactez l'ICFA pour des conseils d'experts et des informations détaillées. Votre future carrière commence ici.`,
        //         // }
        //     ]
        // };
    },
    async asyncData({ params, store }) {
        let instances = store.state.instances;
        let infoGenerales = JSON.parse(JSON.stringify(store.state.infoGenerales));


        return {
            params, instances, infoGenerales
        }
    },
}

